import { addToGlobalThisRet } from "@plugins";
import ColumnResizer from "column-resizer";
import Tablesort from "tablesort";

window.Tablesort = Tablesort;

// =========== Ресайз колонок таблицы  ===========
function initBaseTablesResize() {
    const baseTables = document.querySelectorAll(".js-base-table-resizable-init");

    for (const baseTable of baseTables) {
        new ColumnResizer(baseTable, {
            liveDrag: true, // с этим свойством ресайз происходит плавно (для повышения производительности можно отключить)
            draggingClass: "rangeDrag",
            innerGripHtml: "<div class='rangeGrip'></div>",
            // minWidth: 120, // минимальная ширина колонки
            headerOnly: false, // изменять размер столбцов можно только через шапку таблицы
            flush: false, // сбрасывает измененые размеры после перезагрузки страницы
            resizeMode: "overflow",
            onResize() {
                // Необходимо, что бы при ресайзе кастомный скролл пересчитывался
                const baseTableMain = baseTable.closest(".js-simplebar");

                baseTableMain.dispatchEvent(
                    new Event("columnResize", {
                        bubbles: true,
                        compose: true,
                    }),
                );
            },
        });
    }
}

// =========== Сортировка таблицы  ===========
function initBaseTablesSort() {
    const sortTables = document.querySelectorAll(".js-tablesort");

    if (sortTables.length > 0) {
        for (const table of sortTables) {
            new Tablesort(table);
        }
    }
}

window.addEventListener("load", () => {
    initBaseTablesResize();
    initBaseTablesSort();
});

addToGlobalThisRet(initBaseTablesResize, "initBaseTablesResize");
addToGlobalThisRet(ColumnResizer, "globalColumnResizer");
